var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMapOrange = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17.436.75-5.86 1.83-5.181-1.293-5.83 1.638V17.25l.822-.233 5.028-1.415 5.201 1.303 5.82-1.82V.75Zm-1.298 1.764v11.619l-3.893 1.216V3.731l3.893-1.217Zm-9.084.274 3.893.973V15.4l-3.893-.973V2.787Zm-1.298.025v11.629l-3.893 1.095V3.908l3.893-1.095Z",
  fill: "#0564AA"
})));
export default SvgMapOrange;